/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconOzon16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconOzon16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <rect width="16" height="16" rx="6" fill="#0069FF" />
            <path
                d="M5.968 16a5.97 5.97 0 0 1-3.337-1.034l1.035-8.133 6.833-2.5 5.468 6.296A6 6 0 0 1 10.03 16H5.968Z"
                fill="#F91155"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.26 5.582c2.605-.721 4.935.123 5.278 1.36.343 1.238-1.22 3.161-3.825 3.883-2.604.721-4.933-.123-5.276-1.36-.343-1.238 1.22-3.161 3.824-3.883Zm-.635-2.294C2.855 4.332.41 7.38 1.161 10.095c.752 2.714 4.418 4.068 8.188 3.024 3.77-1.045 6.216-4.092 5.464-6.807-.752-2.715-4.418-4.069-8.188-3.024Z"
                fill="#fff"
            />
        </SVGContainer>
    );
});

const IconOzon24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconOzon24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z" fill="#0069FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 18.017A6 6 0 0 1 18 24H6a5.984 5.984 0 0 1-2.197-.415L5.5 10.25 15.75 6.5 24 16v2.017Z"
                fill="#F91155"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.892 8.373c3.907-1.082 7.401.184 7.916 2.04.514 1.857-1.83 4.742-5.737 5.824-3.907 1.082-7.4-.184-7.915-2.04-.514-1.857 1.83-4.741 5.736-5.824ZM9.94 4.932C4.284 6.499.615 11.07 1.743 15.142c1.128 4.072 6.627 6.103 12.282 4.536 5.654-1.566 9.324-6.138 8.195-10.21-1.128-4.072-6.627-6.103-12.281-4.536Z"
                fill="#fff"
            />
        </SVGContainer>
    );
});

export const IconOzon = forwardRef<SVGSVGElement, IconBaseProps>(function IconOzon(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconOzon16 {...iconProps} />;
        case '24':
            return <IconOzon24 {...iconProps} />;
        default:
            return <IconOzon24 {...iconProps} />;
    }
});
